import React, { useState } from "react";
import { Building2, UserPlus, Megaphone, ClipboardList, ScrollText, BarChart3, Tags, FileCheck, Star } from "lucide-react";
import { DashLayout } from "../../components/kit";
import { OpsAds, OpsInvites, OpsOrgs } from "./OpsSections";
import { OpsAnalytics, OpsAudit, OpsRequests, OpsTaxonomy } from "./OpsInsight";
import { OpsApplications, OpsReviews } from "./OpsTrust";

const TABS: [string, string, any][] = [
  ["orgs", "Organizations & plans", Building2], ["applications", "Vendor applications", FileCheck], ["invites", "Onboarding", UserPlus], ["ads", "Ad review", Megaphone],
  ["requests", "Requests", ClipboardList], ["reviews", "Ratings moderation", Star], ["audit", "Audit", ScrollText], ["analytics", "Analytics", BarChart3], ["taxonomy", "Trades & areas", Tags],
];

export default function OpsHome() {
  const [tab, setTab] = useState("orgs");
  return (
    <DashLayout title="Operations Dashboard" idPrefix="ops" value={tab} onChange={setTab} tabs={TABS}>
      <p className="mb-4 text-xs text-[var(--muted)]">Ops can approve, review and audit. Ops cannot grant or edit customer consent and never sees protected request fields.</p>
      {tab === "orgs" && <OpsOrgs />}
      {tab === "applications" && <OpsApplications />}
      {tab === "reviews" && <OpsReviews />}
      {tab === "invites" && <OpsInvites />}
      {tab === "ads" && <OpsAds />}
      {tab === "requests" && <OpsRequests />}
      {tab === "audit" && <OpsAudit />}
      {tab === "analytics" && <OpsAnalytics />}
      {tab === "taxonomy" && <OpsTaxonomy />}
    </DashLayout>
  );
}
